module.exports = "<div class=\"aui-loader\" ng-show=\"$ctrl.show\" ng-class=\"{firstLoad:$ctrl.firstLoad == true}\">\n\t<div class=\"aui-loader__container loader--fade text-center no-m\">\n\t\t<!-- <div class=\"block bg-color-utente-dr spinner-blink\"></div>\n\t\t<div class=\"block bg-color-utente spinner-blink\"></div>\n\t\t<div class=\"block bg-color-utente-lt spinner-blink\"></div> -->\n\t\t<img src=\"" + require("./img/loader.gif") + "\">\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/loader/loader.html
// module id = 27
// module chunks = 1 2 4